import React from 'react';
import { useIntl } from 'react-intl';

import { LoadingWizardScreen } from '@futrli/ui-components/components/sidebar/wizard/screens/loading-wizard-screen/loading-wizard-screen';
import { CreateReportSidebarMode } from '../create-report-sidebar';

export interface ReportCreatingScreenProps {
  mode?: CreateReportSidebarMode;
}

export const ReportCreatingScreen = ({ mode = 'report' }: ReportCreatingScreenProps) => {
  const intl = useIntl();
  const isDashboard = mode === 'dashboard';
  
  return (
    <LoadingWizardScreen
      text={
        isDashboard
          ? intl.formatMessage({ id: 'reporting.creating_dashboard', defaultMessage: 'Creating dashboard...' })
          : intl.formatMessage({ id: 'reporting.creating_report', defaultMessage: 'Creating report...' })
      }
    />
  );
};
